import React from 'react';
import './Footer.css';

const NAV_LINKS = [
  { label: 'Services', sectionId: 'services' },
  { label: 'Apps',     sectionId: 'apps'     },
  { label: 'Contact',  sectionId: 'contact'  },
];

const APP_LINKS = [
  { label: 'Oraculus',       available: false },
  { label: 'Prompt Builder', available: true,  href: 'https://pb.southlabs.ai' },
];

const SOCIAL_LINKS = [
  { label: 'LinkedIn', available: false },
  { label: 'X',        available: false },
  { label: 'GitHub',   available: false },
];

function scrollTo(sectionId) {
  const appEl  = document.querySelector('.App');
  const target = document.getElementById(sectionId);
  if (appEl && target) {
    appEl.scrollTo({ top: appEl.scrollTop + target.getBoundingClientRect().top, behavior: 'smooth' });
  }
}

function FooterCol({ title, children }) {
  return (
    <div className="footer-col">
      <p className="footer-col-title">{title}</p>
      {children}
    </div>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-inner">

          {/* Brand */}
          <div className="footer-brand">
            <img
              src="/southlabs3.png"
              alt="Southlabs"
              className="footer-icon"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                const appEl = document.querySelector('.App');
                if (appEl) appEl.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            />
            <p className="footer-tagline">Your AI adoption partner.</p>
          </div>

          {/* Navigate */}
          <FooterCol title="Navigate">
            {NAV_LINKS.map(({ label, sectionId }) => (
              <button key={label} className="footer-link" onClick={() => scrollTo(sectionId)}>
                {label}
              </button>
            ))}
          </FooterCol>

          {/* Products */}
          <FooterCol title="Products">
            {APP_LINKS.map(({ label, available, href }) => available ? (
              <a key={label} className="footer-link" href={href} target="_blank" rel="noopener noreferrer">
                {label}
              </a>
            ) : (
              <span key={label} className="footer-link footer-link--dim">{label}</span>
            ))}
          </FooterCol>

          {/* Connect */}
          <FooterCol title="Connect">
            {SOCIAL_LINKS.map(({ label, available, href }) => available ? (
              <a key={label} className="footer-link" href={href} target="_blank" rel="noopener noreferrer">
                {label}
              </a>
            ) : (
              <span key={label} className="footer-link footer-link--dim">{label}</span>
            ))}
          </FooterCol>

        </div>

        <p className="footer-copy">&copy; 2026 southlabs.ai — All rights reserved</p>
      </div>
    </footer>
  );
}

export default Footer;
